import { render, staticRenderFns } from "./selectionList.vue?vue&type=template&id=50f0845b&scoped=true"
import script from "./selectionList.vue?vue&type=script&lang=js"
export * from "./selectionList.vue?vue&type=script&lang=js"
import style0 from "./selectionList.vue?vue&type=style&index=0&id=50f0845b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f0845b",
  null
  
)

export default component.exports